export enum GoalCreateFormMode {
  CREATE = 'CREATE',
  EDIT_DRAFT = 'EDIT_DRAFT',
  // EDIT = 'EDIT'
}
